import { ThemeConfig } from 'antd';
import { PresetColorType, SeedToken } from 'antd/es/theme/internal';

export const defaultPresetColors: Partial<PresetColorType> = {
  blue: '#136FD8',
  green: '#00B14F',
  red: '#D42E1C',
  orange: '#F09800',
};
const seedToken: Partial<SeedToken> = {
  ...defaultPresetColors,
  colorPrimary: defaultPresetColors.green,
  colorSuccess: defaultPresetColors.green,
  colorWarning: defaultPresetColors.orange,
  colorError: defaultPresetColors.red,
  colorInfo: defaultPresetColors.blue,
  fontFamily: "'Inter'",
  fontSize: 14,
};
export const GRAB_THEME: ThemeConfig = {
  token: {
    ...seedToken,
    borderRadius: 12,
    colorBgLayout: '#F5F5F5',
    colorText: '#3D3D3D',
    colorTextPlaceholder: '#A3A3A3',
    colorTextDisabled: '#707070',
    colorPrimaryHover: '#00804A',
    colorPrimaryActive: '#03633E',
  },
  components: {
    Alert: {
      margin: 16,
    },
    DatePicker: {
      controlHeight: 40,
    },
    Layout: {
      borderRadius: 8,
      headerBg: '#00804A',
    },
    Input: {
      borderRadius: 12,
      controlHeight: 40,
      lineHeight: 1,
      fontSize: 14,
    },
    Menu: {
      itemSelectedColor: '#005339',
      itemSelectedBg: '#EEF9F9',
    },
    Select: {
      controlHeight: 40,
    },
    Tag: {
      borderRadiusSM: 12,
    },
    Tooltip: {
      colorBgDefault: '#3D3D3D',
      fontSize: 14,
    },
    Typography: {
      fontSize: 18,
      margin: 0,
    },
    Pagination: {
      colorBgContainer: seedToken.colorPrimary,
    },
  },
};
